import React, { useState } from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  addMonths,
  subMonths,
  isSameMonth,
  getWeek,
} from "date-fns";
import { useNavigate } from "react-router-dom";
import "./Calendar.css";

const Calendar = () => {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);
  const [viewMode, setViewMode] = useState("month");
  const navigate = useNavigate();

  const events = [
    {
      year: 2025,
      month: 3, // April
      day: 10,
      title: "Webinar: How Email & Mobile Verification Can Cut Customer Onboarding Costs?",
      time: "", // No time, so it's treated as an all-day event
      duration: "",
      speaker: "",
      description: ``,
      link: "",
      image: "",
      redirectUrl: "/how-email-and-mobile-verification-can-cut-customer-onboarding-costs",
      isCompleted: true, // Mark this event as completed
    },
    {
      year: 2025,
      month: 5, // June
      day: 19,
      title: "Welcome MSB Meet-Up 19th June 2025",
      time: "", // No time, so it's treated as an all-day event
      duration: "",
      speaker: "",
      description: ``,
      link: "",
      image: "",
      redirectUrl: "/welcome-msb-meet-june-2025",
      isCompleted: true, // Mark this event as completed
    },
    {
      year: 2025,
      month: 6, // July
      day: 1,
      title: "Webinar: Do's & Don'ts to get a bank account for your MSB business",
      time: "", // No time, so it's treated as an all-day event
      duration: "",
      speaker: "",
      description: ``,
      link: "",
      image: "",
      redirectUrl: "/dosand-donts-to-get-a-bank-account-for-your-msb-business",
      isCompleted: true, // Mark this event as completed
    },
    {
      year: 2025,
      month: 11, // December (0-based month index)
      day: 4,
      title: "Thinking about leasing a new office, buying commercial property, or hiring skilled global talent?",
      time: "",
      duration: "60 mins",
      speaker: "Mr. Rohat Kumar",
      isCompleted: true,
      redirectUrl: "/legal-insights-on-buying-or-leasing-commercial-property",
      link: "",

    },
    {
      year: 2026,
      month: 2, // December (0-based month index)
      day: 13,
      title: "HMRC Visit Preparation",
      time: "",
      duration: "60 mins",
      speaker: "Mr. Ajinkya Patil",
      isCompleted: true,
      redirectUrl: "/hmrc-visit-preparation",
      //  redirectUrl: "/eventsdetails",
      link: "",

    },
    {
      year: 2026,
      month: 3, // December (0-based month index)
      day: 16,
      title: "Annual Members Meet 2026",
      time: "",
      duration: "",
      speaker: "",
      image: "/assets/images/event-banner/members-meet-2026.png",
      isCompleted: true,
      redirectUrl: "/annual-members-meet-2026",
      link: "",

    },
    {
      year: 2026,
      month: 5, // June
      day: 26,
      title: "Summer Members Meet 2026",
      time: "",
      duration: "",
      speaker: "",
      isCompleted: true,
      redirectUrl: "/summer-meet-2026",
      link: "",

    },

    // {
    //   month: 6, // July
    //   day: 1,
    //   title: "Webinar: Do's & Don'ts to get a bank account for your MSB business",
    //   time: "01:00 PM BST",
    //   duration: "60 mins",
    //   speaker: "Mr. Steve Allen",
    //   description: `
    //   <h5>Opening a bank account for your MSB feels impossible? You’re not alone.</h5>
    //     <p>Join us for a power-packed session where <strong>Steve</strong> unveils the insider do’s and don’ts that can make all the difference — from red flags to green lights, and everything in between.</p>
    //     <h5>What you'll learn</h5>
    //     <ul>
    //       <li>A brief overview of the remittance market in the UK and Europe.</li>
    //       <li>Key challenges remittance companies face in banking.</li>
    //       <li>Do’s and Don’ts of onboarding with banking providers.</li>
    //       <li>Cross-border payment challenges.</li>
    //       <li>The rise of stable coins and the advantage of their solution.</li>
    //       <li>Advice for MSBs looking to scale.</li>
    //     </ul>
    //     <p><strong>Get the clarity, confidence, and strategy your MSB needs — all in one session.</strong></p>
    //   `,
    //   link: "",
    //   image: "/assets/images/event-banner/Steve-Allen.png",
    // },
  ];

  const eventColors = ["#333", "#e91e63", "#ff9800", "#8e24aa", "#4caf50"];

  const handleViewChange = (mode) => setViewMode(mode);

  // Normalize event months so both 0-based and 1-based month values work
  const getDayEvents = (date) =>
    events.filter((ev) => {
      const evMonth = typeof ev.month === "number" ? (ev.month > 11 ? ev.month - 1 : ev.month) : new Date(ev.year, ev.month).getMonth();
      return (
        ev.year === date.getFullYear() &&
        evMonth === date.getMonth() &&
        ev.day === date.getDate()
      );
    });

  const handleEventClick = (event, date) => {
    if (event.redirectUrl) {
      navigate(event.redirectUrl);
    } else {
      navigate("/eventsdetails", { state: { event: { ...event, date } } });
    }
  };

  const renderHeader = () => (
    <div className="calendar-header">
      <div className="calendar-controls">
        <button onClick={() => setCurrentDate(subMonths(currentDate, 1))}>
          {"<"}
        </button>
        <button className="today-btn" onClick={() => setCurrentDate(today)}>
          Today
        </button>
        <button onClick={() => setCurrentDate(addMonths(currentDate, 1))}>
          {">"}
        </button>
      </div>
      <div className="calendar-title">{format(currentDate, "MMMM yyyy")}</div>
      <div className="view-controls">
        {["month", "week", "day"].map((mode) => (
          <button
            key={mode}
            className={`view-button ${viewMode === mode ? "active" : ""}`}
            onClick={() => handleViewChange(mode)}
          >
            {mode.charAt(0).toUpperCase() + mode.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );

  const renderDaysHeader = () => {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return (
      <>
        <div className="week-label-header"></div>
        {days.map((day, idx) => (
          <div key={idx} className="day-header">
            {day}
          </div>
        ))}
      </>
    );
  };

  const renderMonthView = () => {
    const monthStart = startOfMonth(currentDate);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);

    const rows = [];
    let day = startDate;

    while (day <= endDate) {
      rows.push(
        <React.Fragment key={`week-${day}`}>
          <div className="week-label">W{getWeek(day)}</div>
          {[...Array(7)].map(() => {
            const clonedDay = new Date(day);
            const isCurrentMonth = isSameMonth(clonedDay, monthStart);
            const dayEvents = getDayEvents(clonedDay);

            const classNames = ["calendar-cell"];
            if (!isCurrentMonth) classNames.push("inactive");

            const eventTags = dayEvents.map((event, idx) => (
              <div
                key={idx}
                className={`event-tag ${idx === 0 ? "first-event" : "other-event"}`}
                style={{
                  backgroundColor: event.isCompleted
                    ? "#939292"
                    : eventColors[idx % eventColors.length],
                  padding: "10px 14px",
                  borderRadius: "10px",
                  marginBottom: "8px",
                  color: "#fff",
                  cursor: "pointer",
                  boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                  transition: "0.2s ease",
                }}
                onClick={() => handleEventClick(event, clonedDay)}
              >
                {/* DATE BADGE */}
                {event.time && (
                  <div
                    style={{
                      display: "inline-block",
                      background: "#ff9800",
                      padding: "3px 8px",
                      borderRadius: "20px",
                      fontSize: "11px",
                      fontWeight: "600",
                      marginBottom: "5px",
                    }}
                  >
                    {event.time}
                  </div>
                )}

                {/* TITLE SMALL FONT */}
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    lineHeight: "18px",
                    marginTop: "2px",
                  }}
                >
                  {event.title}
                </div>
              </div>
            ));


            day = addDays(day, 1);
            return (
              <div
                key={clonedDay.toISOString()}
                className={classNames.join(" ")}
              >
                <div className="cell-date">{format(clonedDay, "d")}</div>
                {eventTags}
              </div>
            );
          })}
        </React.Fragment>
      );
    }

    return (
      // MODIFIED: Wrapped in a scroll container for mobile view
      <div className="calendar-scroll-container">
        <div className="calendar-days">{renderDaysHeader()}</div>
        <div className="calendar-grid">{rows}</div>
      </div>
    );
  };

  const renderWeekView = () => {
    const weekStart = startOfWeek(currentDate);
    const days = [];

    for (let i = 0; i < 7; i++) {
      const day = addDays(weekStart, i);
      const dayEvents = getDayEvents(day);

      days.push(
        <div key={day} className="calendar-cell">
          <div className="cell-date">{format(day, "EEE dd")}</div>
          {dayEvents.map((event, idx) => (
            <div
              key={idx}
              className={`event-tag ${idx === 0 ? "first-event" : "other-event"
                }`}
              style={{
                backgroundColor: event.isCompleted
                  ? "#939292"
                  : eventColors[idx % eventColors.length],
              }}
              onClick={() => handleEventClick(event, day)}
            >
              {event.time && <div>{event.time}</div>}
              <div>{event.title}</div>
            </div>
          ))}
        </div>
      );
    }

    return (
      // MODIFIED: Wrapped in a scroll container for mobile view
      <div className="calendar-scroll-container">
        <div className="calendar-days">
          <div className="week-label-header"></div>
          {days.map((_, i) => (
            <div key={i} className="day-header">
              {format(addDays(weekStart, i), "EEE")}
            </div>
          ))}
        </div>
        <div className="calendar-grid week-view">
          <div className="week-label">W{getWeek(currentDate)}</div>
          {days}
        </div>
      </div>
    );
  };

  const renderDayView = () => {
    const hours = [...Array(24)].map(
      (_, i) => `${i === 0 ? 12 : i % 12}${i < 12 ? "am" : "pm"}`
    );
    const allEvents = getDayEvents(currentDate);

    const allDayEvents = allEvents.filter((e) => !e.time);
    const timedEvents = allEvents.filter((e) => e.time);

    const getHour = (time) => {
      if (!time || time === "--:--") return -1;
      const match = time.match(/(\d+)(?::(\d+))?\s*(am|pm)/i);
      if (!match) return -1;
      let hour = parseInt(match[1], 10);
      const ampm = match[3].toLowerCase();
      if (ampm === "pm" && hour !== 12) hour += 12;
      if (ampm === "am" && hour === 12) hour = 0;
      return hour;
    };

    return (
      <div className="day-view">
        <div className="day-header-row">
          <div className="week-label">W{getWeek(currentDate)}</div>
          <div className="day-title">
            {format(currentDate, "EEEE, MMMM d, yyyy")}
          </div>
        </div>

        <div className="day-all-day">
          <div className="time-label">all-day</div>
          <div className="event-container">
            {allDayEvents.map((event, idx) => (
              <div
                key={idx}
                className="event-block"
                style={{
                  backgroundColor: event.isCompleted
                    ? "#939292"
                    : eventColors[idx % eventColors.length],
                }}
                onClick={() => handleEventClick(event, currentDate)}
              >
                {event.title}
              </div>
            ))}
          </div>
        </div>

        {hours.map((label, i) => {
          const eventsThisHour = timedEvents.filter(
            (e) => getHour(e.time) === i
          );
          return (
            <div className="hour-row" key={label}>
              <div className="time-label">{label}</div>
              <div className="event-container">
                {eventsThisHour.map((event, idx) => (
                  <div
                    key={idx}
                    className="event-block"
                    style={{
                      backgroundColor: event.isCompleted
                        ? "#939292"
                        : eventColors[idx % eventColors.length],
                    }}
                    onClick={() => handleEventClick(event, currentDate)}
                  >
                    {event.title}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };


  return (
    <div className="calendar-container">
      {renderHeader()}
      {viewMode === "month" && renderMonthView()}
      {viewMode === "week" && renderWeekView()}
      {viewMode === "day" && renderDayView()}
    </div>
  );
};

export default Calendar;